export const BUTTON_VARIANT = {
  initial: { opacity: 0, x: -50 },
  animate: { opacity: 1, x: 0 },
};